"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var esri_loader_1 = require("esri-loader");
;
var MapView = function (_a) {
    var webmapId = _a.webmapId, padding = _a.padding, initialMapCenterLocation = _a.initialMapCenterLocation, children = _a.children, onStationary = _a.onStationary;
    var mapDivRef = React.useRef();
    var _b = React.useState(null), mapView = _b[0], setMapView = _b[1];
    var initMapView = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, MapView_1, WebMap, _b, lat, lon, zoom, center, view_1, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, esri_loader_1.loadModules([
                            'esri/views/MapView',
                            'esri/WebMap',
                        ])];
                case 1:
                    _a = _c.sent(), MapView_1 = _a[0], WebMap = _a[1];
                    _b = initialMapCenterLocation || {}, lat = _b.lat, lon = _b.lon, zoom = _b.zoom;
                    center = lon && lat ? [lon, lat] : undefined;
                    view_1 = new MapView_1({
                        container: mapDivRef.current,
                        map: new WebMap({
                            portalItem: {
                                id: webmapId
                            }
                        }),
                        padding: padding,
                        center: center,
                        zoom: zoom,
                        highlightOptions: {
                            haloOpacity: 0,
                            fillOpacity: 0
                        }
                    });
                    view_1.when(function () {
                        setMapView(view_1);
                    });
                    return [3, 3];
                case 2:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var addWatchEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var watchUtils, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, esri_loader_1.loadModules([
                            'esri/core/watchUtils'
                        ])];
                case 1:
                    watchUtils = (_a.sent())[0];
                    watchUtils.whenTrue(mapView, 'stationary', function () {
                        if (mapView.zoom === -1) {
                            return;
                        }
                        var centerLocation = {
                            lat: mapView.center && mapView.center.latitude
                                ? +mapView.center.latitude.toFixed(3)
                                : 0,
                            lon: mapView.center && mapView.center.longitude
                                ? +mapView.center.longitude.toFixed(3)
                                : 0,
                            zoom: mapView.zoom
                        };
                        onStationary(centerLocation);
                    });
                    return [3, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error(err_2);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var addDefExpToVIIRSLayers = function () {
        var VIIRSLayers = mapView.map.allLayers
            .filter(function (d) { return d.title.includes('VIIRS'); });
        VIIRSLayers.forEach(function (layer) {
            layer.definitionExpression = "esritimeutc >=  CURRENT_TIMESTAMP - INTERVAL '48' HOUR";
        });
    };
    React.useEffect(function () {
        esri_loader_1.loadCss();
        initMapView();
    }, []);
    React.useEffect(function () {
        if (mapView) {
            addWatchEvent();
            addDefExpToVIIRSLayers();
        }
    }, [mapView]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                width: '100%',
                height: '100%',
            }, ref: mapDivRef }),
        React.Children.map(children, function (child) {
            return React.cloneElement(child, {
                mapView: mapView,
            });
        })));
};
exports.default = MapView;
